import { useRepositoryMutation } from '@mews-commander/data-access';
import { useDateTimeLocalizationInfo, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { prepareRoutingRulesValues } from '../utils/formValues';
import { RoutingRuleFormValues } from '../schemas';

export const useAddRoutingRulesMutation = ({ onSuccess }: { onSuccess: (ruleId?: string) => void }) => {
    const recurringRoutingRulesEnabled = useFeatureFlag(FeatureFlag.recurringRoutingRulesEnabled);
    const granularRoutingRulesConditionsExtensionEnabled = useFeatureFlag(
        FeatureFlag.granularRoutingRulesConditionsExtensionEnabled
    );
    const localizationInfo = useDateTimeLocalizationInfo();
    return useRepositoryMutation('routingRules', 'newAdd', {
        transformParams: (values: RoutingRuleFormValues) =>
            prepareRoutingRulesValues({
                values,
                localizationInfo,
                recurringRoutingRulesEnabled,
                granularRoutingRulesConditionsExtensionEnabled,
            }),
        invalidateQueries: {
            routingRules: ['newGetAll'],
        },
        onSuccess: (data) => {
            const ruleId = data?.routingRules?.[0]?.id;
            onSuccess(ruleId);
        },
    });
};
